import { get, set, del } from 'idb-keyval';

class AsyncStorage {
  static getItem = (key) => get(key);
  static setItem = (key, value) => set(key, value);
  static removeItem = (key) => del(key);
}

export default AsyncStorage;
